import { useLingui } from '../../../../../../node_modules/@lingui/react/dist/index.mjs';
import React__default from 'react';
import Button from '../../components/atoms/Button.mjs';
import { useGlobalReducer } from '../GlobalContextProvider.mjs';

const UsePasswordButton = ({ email })=>{
    const [, dispatch] = useGlobalReducer();
    const { i18n: $__i18n, _: $__ } = useLingui();
    const handleUsePassword = ()=>{
        dispatch({
            type: 'use_password_auth',
            email
        });
    };
    return /*#__PURE__*/ React__default.createElement(Button, {
        variant: "ghost",
        onClick: handleUsePassword
    }, $__i18n._({
        id: "button.usePassword"
    }));
};

export { UsePasswordButton as default };
//# sourceMappingURL=UsePasswordButton.mjs.map
